import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { sliderVariationStrategies } from './sliderVariationStrategies';
import { SWIPER_EFFECT } from '../../../../constants/globalConstants';

// Strategy application function
export var applySliderVariationStrategy = function applySliderVariationStrategy(carouselOptions, timePerSlide) {
  // Start with default configuration
  var config = {
    autoplay: true,
    // Default is true for autoplay
    effect: SWIPER_EFFECT.SLIDE.NAME,
    parallaxType: undefined,
    parallaxOnScroll: false,
    timePerSlide: 8000
  };

  // Apply pre-defined variation if selected
  if (carouselOptions !== null && carouselOptions !== void 0 && carouselOptions.predefinedVariation) {
    var strategy = sliderVariationStrategies[carouselOptions.predefinedVariation];
    if (strategy) {
      config = _objectSpread(_objectSpread({}, config), strategy);
    }
  }

  // Override with individually configured settings
  if ((carouselOptions === null || carouselOptions === void 0 ? void 0 : carouselOptions.autoplay) !== undefined) {
    config.autoplay = carouselOptions.autoplay;
  }
  if (carouselOptions !== null && carouselOptions !== void 0 && carouselOptions.effect) {
    config.effect = carouselOptions.effect;
  }
  if (carouselOptions !== null && carouselOptions !== void 0 && carouselOptions.parallaxType) {
    config.parallaxType = carouselOptions.parallaxType;
  }
  if (carouselOptions && typeof carouselOptions.parallaxOnScroll === 'boolean') {
    config.parallaxOnScroll = carouselOptions.parallaxOnScroll;
  }
  if (timePerSlide) {
    config.timePerSlide = timePerSlide;
  }
  return config;
};